/* eslint-disable react/no-array-index-key */
import React, { useEffect } from 'react'
import { useDispatch, connect } from 'react-redux'

// libs
import { filtroProvincia } from '@navent-jobs/interlinking'

// ui-kit
import { useWindowSize } from '@navent-jobs/ui-kit/hooks/window-size'
import Pagination from '@navent-jobs/ui-kit/components/pagination-fluid'

// components
import AdManager from '../ads'
import ListadoSponsor from '../sponsor'
import ListadoAvisosPlaceholder from '../card/ListadoAvisosPlaceholder'
import ListEmptyState from '../../../../components/empty-state'
import ListadoAvisosRecomendados from '../avisos-recomendados/index'
import { BusquedasRecientes } from '../busquedas-recientes'

// constants
import { DataLayers as PageDataLayers } from '../../../../constants/gtm-events-listado-page'

// store
import { setFilterSettings } from '../../../../redux/actions/filters'
import {
  getAvisos as getAvisosV1,
  getAvisosV2,
  resetListadoAvisosStore,
} from '../../../../redux/actions/listado-avisos'
import { getSettingsSort } from '../../../../redux/actions/sort'
import { getRecomendadosListado } from '../../../../redux/actions/recomendados'
import { PaginationDataLayers } from '../../../../constants/gtm-events-pagination'
import features from '../../../../constants/features-per-country'
import { SITE_ID } from '../../../../constants'
import { showSnackbar } from '../../../../redux/actions/applicant/curriculum/snackbar'
import { userLoggedIn } from '../../../../utils/cookies'
import ListadoAvisosCard from '../listado-avisos-card'
import { Aviso, FilterCore  } from '../../../../redux/types/listado-avisos'

const SHOW_RECOMMENDED_JOB_POSTING_AMOUNT = 5
const RECOMMENDED_JOB_POSTING_AMOUNT = 5
const TOTAL_CARDS_PLACEHOLDER = 20

// features
const productBannersFeature = features[SITE_ID || 'BMAR'].marketplace?.banners?.enabled
const googleAdsListEnabled = features[SITE_ID || 'BMAR'].googleAds?.list?.enabled
const googleAdsPaginationEnabled = features[SITE_ID || 'BMAR'].googleAds?.pagination?.enabled
const recomendadosEnabled = features[SITE_ID || 'BMAR'].listadoAvisos?.recomendados?.enabled

const bannerFilters = activeLanding => {
  return !activeLanding || activeLanding === ''
}

const onClickAviso = (event, url, isMobile, isBumeranInZona) => {
  if (!(event.ctrlKey || event.metaKey)) {
    event.preventDefault()
    if (isBumeranInZona) {
      window.open(`https://www.bumeran.com.ar${url}`, '_blank')
    } else {
      window.open(url, isMobile ? '_self' : '_blank')
    }
  }
}

const searchRecomendadosListado = ({ success, showRecommended, dispatch }) => {
  if (success && showRecommended) {
    dispatch(
      getRecomendadosListado({
        limit: RECOMMENDED_JOB_POSTING_AMOUNT,
        source: 'empty_list_recomendados_postulante',
      })
    )
  }
}

const searchAvisosV2Enabled = features[SITE_ID || 'BMAR'].searchAvisosV2.enabled
const getAvisos = searchAvisosV2Enabled ? getAvisosV2 : getAvisosV1

interface ListadoAvisosInterface {
  activeAviso: any
  avisos: Aviso[]
  filtersApplied: FilterCore[]
  pagination: any
  loading: boolean
  success: boolean
  parentRoute: any
  ads: any
  activeLanding: string
  saveJobPostingStates: any
  resultsNotFound?: boolean
}

const ListadoAvisos = ({
  activeAviso,
  avisos,
  filtersApplied,
  pagination,
  loading,
  success,
  parentRoute,
  ads,
  activeLanding,
  saveJobPostingStates,
  resultsNotFound,
}: ListadoAvisosInterface) => {
  const queryParams = new URLSearchParams(parentRoute.location.search)
  const dispatch = useDispatch()
  const isUserLoggedIn = userLoggedIn()
  const { isMobile, isTabletPortrait, isDesktop } = useWindowSize()
  const { match } = parentRoute
  const pageParam = Number(new URLSearchParams(parentRoute.location.search).get('page'))
  const pageGrailsParam =
    match.url.match(/(.)-pagina-(\d*).html/) && match.url.split('-pagina-')[1].replace('.html', '')
  const currentPage = !pageGrailsParam ? (pageParam === 0 ? 0 : pageParam - 1) : pageGrailsParam - 1
  const showRecommended =
    recomendadosEnabled && isUserLoggedIn && (!avisos || avisos.length <= SHOW_RECOMMENDED_JOB_POSTING_AMOUNT)

  const loadPage = page => {
    dispatch(
      getAvisos({
        sortParams: queryParams,
        filtros: [...filtroProvincia(parentRoute.match.params)],
        page,
        match,
      })
    )
  }

  const onClickAvisoHandler = (event, url, isBumeranInZona) => {
    onClickAviso(event, url, isMobile, isBumeranInZona)
  }

  useEffect(() => {
    PaginationDataLayers.paginationOnUse(Number(currentPage) + 1)
  }, [currentPage])

  useEffect(() => {
    dispatch(getSettingsSort())
  }, [])

  useEffect(() => {
    PageDataLayers.onload(filtersApplied, 'Listado', isUserLoggedIn)

    if (filtersApplied && bannerFilters(activeLanding)) {
      dispatch(resetListadoAvisosStore())
      dispatch(setFilterSettings())
    }
  }, [filtersApplied])

  useEffect(() => {
    if (avisos && document.documentElement.scrollTo) {
      document.documentElement.scrollTo(0, 0)
    }
  }, [avisos, document])

  useEffect(() => {
    loadPage(Number(currentPage))
  }, [parentRoute.match.url, parentRoute.location.search])

  useEffect(() => {
    // returned function will be called on component unmount
    return () => {
      dispatch(resetListadoAvisosStore())
      dispatch(setFilterSettings())
    }
  }, [])

  // Guardar Aviso: useEffect() para renderizar el snackbar despues de guardar un aviso desde la card
  useEffect(() => {
    if (saveJobPostingStates?.success) {
      dispatch(showSnackbar('Guardaste este aviso', 'icon-bold-heart'))
    }
  }, [saveJobPostingStates?.success])

  useEffect(() => {
    searchRecomendadosListado({ success, showRecommended, dispatch })
  }, [success])

  if (resultsNotFound) {
    return (
      <>
        <ListEmptyState />
        {(isMobile || isTabletPortrait) && <BusquedasRecientes loading={loading} />}
        <ListadoAvisosRecomendados showRecommended={showRecommended} />
      </>
    )
  }

  if (loading) {
    return <ListadoAvisosPlaceholder total={TOTAL_CARDS_PLACEHOLDER} />
  }

  return (
    <>
      <ListadoSponsor onClick={onClickAvisoHandler} />

      <ListadoAvisosCard
        activeAviso={activeAviso}
        avisos={avisos}
        ads={ads}
        activeLanding={activeLanding}
        onClickAvisoHandler={onClickAvisoHandler}
        isFirstPage={currentPage === 0}
      />

      {avisos?.length < 10 && ads && isDesktop && !productBannersFeature && googleAdsListEnabled && (
        <AdManager name="listado-google-list" />
      )}

      <ListadoAvisosRecomendados showRecommended={showRecommended} />

      <Pagination
        {...pagination}
        currentPage={Number(currentPage) + 1}
        currentUrl={window.location.pathname}
        states={{ loading }}
        queryParams={queryParams}
      />

      {isDesktop && googleAdsPaginationEnabled && <AdManager name="listado-google-pagination" />}
    </>
  )
}

const states = ({ listadoAvisosStore, filtersStore, activeAvisoStore, saveJobPostingStore }) => ({
  activeAviso: activeAvisoStore,
  filtersApplied: filtersStore.filtersApplied,
  avisos: listadoAvisosStore.avisos,
  pagination: listadoAvisosStore.pagination,
  loading: listadoAvisosStore.loading,
  success: listadoAvisosStore.success,
  ads: listadoAvisosStore.ads,
  activeLanding: listadoAvisosStore.activeLanding,
  saveJobPostingStates: saveJobPostingStore && saveJobPostingStore.setSaveJobPosting.states,
})

export default connect(states)(ListadoAvisos)
